import React from "react";

import {
    InterdocumentCheckerResult,
    InterdocumentCheckStatus,
    InterdocumentCheckType,
} from "../../../../../Engine/Core/ErrorManager/Utils/Models";
import { InterdocumentCheckIssue } from "../ErrorItem/InterdocumentCheckIssue";
import { DEFAULT_SUCCESS_DESCRIPTION } from "../../../../../Engine/Core/ErrorManager/Utils/Utils";
import { ListItemWrapper } from "../ErrorItem/ErrorsItem.styles";
import { InterdocumentCheckedReport } from "../ErrorItem/InterdocumentCheckedReport";

import { ErrorGroupHeaderSticky } from "./ErrorGroupHeaderSticky";
import { GroupWrapper } from "./ErrorsGroup.styles";

interface InterdocumentChecksProps {
    interdocumentCheckerResult?: InterdocumentCheckerResult | null;
}

export const InterdocumentChecks = (props: InterdocumentChecksProps) => {
    const getContent = (): JSX.Element | JSX.Element[] | null => {
        const defaultSuccess = (
            <ListItemWrapper>
                <InterdocumentCheckIssue
                    type={InterdocumentCheckType.Fine}
                    issue={{ description: DEFAULT_SUCCESS_DESCRIPTION }}
                />
            </ListItemWrapper>
        );

        if (!props.interdocumentCheckerResult) {
            return defaultSuccess;
        }

        if (props.interdocumentCheckerResult.status === InterdocumentCheckStatus.Fail) {
            return (
                <ListItemWrapper>
                    <InterdocumentCheckIssue
                        type={InterdocumentCheckType.Warning}
                        issue={{
                            description: "Не удалось свериться с другими отчетами",
                        }}
                    />
                </ListItemWrapper>
            );
        }

        const checksIssues = (props.interdocumentCheckerResult?.checks || []).filter(
            it => it.type === InterdocumentCheckType.Issues
        );
        const checksError = (props.interdocumentCheckerResult?.checks || []).filter(
            it => it.type === InterdocumentCheckType.Error
        );
        const checksWarning = (props.interdocumentCheckerResult?.checks || []).filter(
            it => it.type === InterdocumentCheckType.Warning
        );
        const checksFine = (props.interdocumentCheckerResult?.checks || []).filter(
            it => it.type === InterdocumentCheckType.Fine
        );
        const checksNotFound = (props.interdocumentCheckerResult?.checks || []).filter(
            it => it.type === InterdocumentCheckType.NotFound
        );
        const checks = checksIssues.concat(checksError).concat(checksWarning).concat(checksFine).concat(checksNotFound);

        if (checks.length === 0) {
            return defaultSuccess;
        }

        return checks.map((check, index) => (
            <ListItemWrapper key={`${check.title}_${index}`}>
                {check.checkedReports?.map(report => (
                    <InterdocumentCheckedReport key={report.id} report={report} />
                ))}
                {check.discrepancyInfo?.issues.map(issue => (
                    <InterdocumentCheckIssue key={issue.id} type={check.type} issue={issue} />
                ))}
                {check.type === InterdocumentCheckType.Fine &&
                    !!check.title &&
                    (!check.discrepancyInfo?.issues || check.discrepancyInfo?.issues.length === 0) && (
                        <div>
                            <InterdocumentCheckIssue
                                type={InterdocumentCheckType.Fine}
                                issue={{ description: check.title }}
                            />
                        </div>
                    )}
                {check.type !== InterdocumentCheckType.Fine &&
                    check.checkedReports == undefined &&
                    check.discrepancyInfo?.issues == undefined && (
                        <InterdocumentCheckIssue type={check.type} issue={{ description: check.title }} />
                    )}
            </ListItemWrapper>
        ));
    };

    return (
        <GroupWrapper data-tid={"protocol-other-report"}>
            <ErrorGroupHeaderSticky title={"Сверка с другими отчетами"} tid={"protocol-other-report-header"} />
            {getContent()}
        </GroupWrapper>
    );
};
